<script>

const Steps = {
    name: "Steps",
    props: {
        name: {
            type: String,
            default: "Step",
        },
        totalSteps: {
            type: Number,
            default: 0,
        },
        currentStep: {
            type: Number,
            default: 0,
        },
        showStepItems: {
            type: Boolean,
            default: true,
        },
        blockClass: {
            type: String,
            default: "mt-3",
        },
    },
    methods: {},
    computed: {
        itemsRange() {
            const array = [];

            // eslint-disable-next-line no-plusplus
            for (let i = 0; i < this.totalSteps; i++) {
                array.push(i);
            }

            return array;
        },
    },
};

export default Steps;
</script>

<template>
    <div :class="{[blockClass]: blockClass}">
        <div class="d-flex flex-row info" data-test="step-current-of-total">
            {{ name }} {{ currentStep }} of {{ totalSteps }}
        </div>
        <div v-if="showStepItems" class="d-flex flex-row">
            <div class="step-item" :class="{'active': itemIdx < currentStep}" v-for="(item, itemIdx) in itemsRange"
                 :key="itemIdx">
            </div>
        </div>
    </div>
</template>

<style scoped>
.info {
    color: #999999;
}
</style>
